import "./styles.css";
import { enablePatches } from "immer";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router/dom";

import { routes } from "./routes";
import { handleReactError, wrappedCreateBrowserRouter } from "./sentry";

const router = wrappedCreateBrowserRouter(routes);

const app = (
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);

enablePatches();

const rootElement = document.createElement("div");
document.body.appendChild(rootElement);

const root = createRoot(rootElement, {
  onCaughtError: handleReactError,
  onRecoverableError: handleReactError,
  onUncaughtError: handleReactError,
});

root.render(app);
